import Select from "react-select";
import { useState, useMemo } from "react";
import { components } from "react-select";

const customStyles = {
    control: (provided, { selectProps }) => ({
        ...provided,
        cursor: "text",
        display: "flex",
        height: "2.25rem",
        alignItems: "center",
        alignSelf: "stretch",
        borderRadius: "0.625rem",
        border: "0.0625rem solid var(--black-10)",
        backgroundColor: "var(--white-100)",
        boxShadow: "none",
        fontSize: "0.875rem",
        width: selectProps.width === 200 ? "200px" : "100%",
        "&:hover": {
            borderColor: "var(--black-10)",
        },
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: "0.625rem",
        overflow: "hidden",
    }),
    option: (provided, state) => ({
        ...provided,
        cursor: "pointer",
        backgroundColor: state.isSelected ? "#eee" : "#fff",
        "&:hover": { backgroundColor: "#f2f2f2" },
        color: "var(--black-100)",
        fontSize: "0.875rem",
    }),
    multiValue: (provided) => ({
        ...provided,
        color: "var(--black-60)",
        borderRadius: "0.625rem",
        border: "0.0625rem solid var(--black-10)",
        backgroundColor: "var(--white-100)",
        overflow: "hidden",
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        borderRadius: "0.5rem",
        border: "0.0625rem solid transparent",
        backgroundColor: "var(--white-100)",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
            backgroundColor: "var(--red-50)",
            color: "var(--red-500)",
            border: "0.0625rem solid var(--red-100)",
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "var(--black-100)",
    }),
};

const CustomSelect = (props) => {
    const [isClosing, setIsClosing] = useState(false);

    const CustomSingleValue = useMemo(() => (props) => {
        return (
            <components.SingleValue {...props} className={`${props.className || ''}`}>
                {props.children}
            </components.SingleValue>
        );
    }, []);

    const CustomOption = useMemo(() => (props) => {
        return (
            <components.Option {...props} className={`${props.className || ''}`}>
                {props.children}
            </components.Option>
        );
    }, []);

    const CustomMenu = useMemo(() => (props) => {
        return (
            <components.Menu 
                {...props} 
                className={`${props.className || ''} ${isClosing ? 'menu-closing' : ''}`}
            >
                {props.children}
            </components.Menu>
        );
    }, [isClosing]);

    const handleMenuClose = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsClosing(false);
            if (props.onMenuClose) {
                props.onMenuClose();
            }
        }, 150);
    };

    return (
        <Select 
            {...props} 
            styles={customStyles} 
            className={`react-select-container ${props.className || ''}`}
            classNamePrefix="react-select"
            components={useMemo(() => ({
                SingleValue: CustomSingleValue,
                Option: CustomOption,
                Menu: CustomMenu,
                ...props.components
            }), [CustomSingleValue, CustomOption, CustomMenu, props.components])}
            onMenuClose={handleMenuClose}
        />
    );
};

export default CustomSelect;
